module.exports = __webpack_public_path__ + "img/bab1t0.85816657.png";